import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext, useFieldArray } from "react-hook-form";
import ErrorMessage from './ErrorMessage';
import {IconDelete} from "./../../assets/images/icons"

const TextArrayInput= ({name, type='text', value, placeholder}) => {
  const { control, register } = useFormContext()
  const { fields, append, remove } = useFieldArray({ name, control, keyName: 'key' });

  return (
    <Controller
      name={name}
      control={control}
      // defaultValue={value.map(v => ({value: v}))}
      render={({
        field, //{ onChange, onBlur, value, name, ref }
        fieldState: { invalid, isTouched, isDirty, error },
        formState,
      }) => (
        <div className="mb-3">
          {fields.map((field, index) => (
            <div className="row d-flex align-items-center">
              <div className="form-floating mb-4 col-md-11">
                <input
                  key={field.key}
                  {...register(`${name}.${index}.value`)} 
                  id={`${name}.${index}`}
                  type={type}
                  className={`form-control rounded-0 ${isTouched && invalid ? "is-invalid" : ""}`}
                  placeholder={placeholder} 
                />
                <label htmlFor={`${name}.${index}`}>{placeholder}</label>
                <ErrorMessage error={field.error}/>
              </div>
              <div className="col-md-1">
                <img src={IconDelete} onClick={() => remove(index)} className="cursor-pointer" alt="ms-0 close icon" height="24px"/>
              </div>
            </div>
          ))}
          {fields.length < 5 && <span onClick={() => append({value: ''})} className="cursor-pointer fs-10 d-block">+ Add new point</span>}
          <ErrorMessage error={error}/>
        </div>
      )}
    />
  )
}

TextArrayInput.defaultProps = {};

TextArrayInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string,
};

export default TextArrayInput;